import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 px-6 ivory-bg">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-font text-5xl md:text-6xl font-bold text-black mb-4">
            Client Testimonials
          </h2>
          <div className="w-24 h-1 gold-bg mx-auto mb-6"></div>
          <p className="body-font text-xl text-gray-700 max-w-3xl mx-auto">
            Hear what our clients say about their experiences with Elysian Evenings
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white p-8 rounded-sm shadow-lg hover:shadow-2xl transition-all border border-gray-200 service-card"
            >
              <Quote className="gold-accent mb-6" size={40} />
              <p className="body-font text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-6">
                <p className="heading-font text-lg font-semibold text-black">
                  {testimonial.name}
                </p>
                <p className="body-font text-sm text-gray-500 mt-1">
                  {testimonial.company}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
